import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
  const { pathname } = useLocation()
  window.apiCalls = {}
  useEffect(() => {
    document.querySelector('body').scrollTo({
      top: 0,
      left: 0,
    })
    //window.apiData = [] //this is a debugger variable
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [pathname])

  return null
}
